import { AddressPin } from '@icons';

/**
 * Blurb address component.
 */
export default function BlurbAddress({ children, className = '' }) {
  if (!children) return null;

  return (
    <p className={`Blurb__address ${className}`}>
      <AddressPin className="Blurb__address-icon" aria-hidden="true" />
      <span className="Blurb__address-text">{children}</span>
    </p>
  );
}
